import type { Components } from '@mui/material/styles';

export default function MUIStepContent(): Components['MuiStepContent'] {
  return {};
}
